import { Div } from 'fractals'
import { TPageContainerProps } from './types'

const PageContainer = ({ children, ...props }: TPageContainerProps) => {
  return <Div {...props}>{children}</Div>
}

export default PageContainer
